import { NgModule } from '@angular/core'
import { ContactBoxNavigationComponent } from './contact-box-navigation.component'
import { CmsComponentsBaseModule } from '../../cms-components-base.module'
import { MbI18nModule } from '../../../../translations/mb-i18n.module'
import { ConvertedComponentData, LinkData } from '../../types'
import { LinkModule } from '../../shared/link/link.module'
import { ContactBoxLineModule } from '../contact-box-line/contact-box-line.module'

@NgModule({
  declarations: [
    ContactBoxNavigationComponent
  ],
  imports: [
    CmsComponentsBaseModule,
    MbI18nModule,
    LinkModule,
    ContactBoxLineModule
  ],
  exports: [
    ContactBoxNavigationComponent
  ]
})
export class ContactBoxNavigationModule {}

export interface ContactBoxNavigationData extends ConvertedComponentData {
  contactData: {
    cityAndZip: string;
    company: string;
    country: string;
    email: string;
    fax: string;
    phone: string;
    street: string;
    ordersEmail: string;
    ordersFax: string;
    ordersPhone: string;
    web: string;
    technicalPhone: string;
    technicalSupportChatAvailability: string;
    technicalSupportEmail: string;
    technicalSupportPhoneAvailability: string;
  };
  linkTechnicalSupport: LinkData;
  linkDistribution: LinkData;
}
